import { ArrowForward } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {buttonStylesBlue } from '../../Components/docsAdministrative/JsObjectStyles';
import Footer from '../../Components/shared/Footer/Footer';
import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import { SelectComponent, TextFieldComponent } from '../../Components/shared/ReusableSmallComponents';
import SelectRadioBtn from '../../Components/shared/SelectGender';
import { typeDemande } from '../../data/Interfaces';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import usePostRequest from '../../hooks/usePostRequest';
import useWindowSize from '../../hooks/useWindowSize';
import { isHttpStatusSuccess } from '../../Utils/utils';

function DemandeDemo() {
    const {postData}= usePostRequest();
    const [demandeType,setDemandeType]=useState('');
    const [nom,setNom]=useState('');
    const [prenom,setPrenom]=useState('');
    const [nomEntreprise,setNomEntreprise]=useState('');
    const [email,setEmail]=useState('');
    const [tele,setTele]=useState('');
    const [message,setMessage]=useState('');
    const [genre, setGenre] = useState('');
    const navigate=useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    usePersistedLanguage();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    const demandeDemo = async () => {
        try {
            const response1 = await postData({url:'/conversation/demandeDemo', payload:
                {
                    demandeType,
                    nom,
                    prenom,
                    genre,
                    nomEntreprise,
                    email,
                    tele,
                    message,
                }
            });
            if (isHttpStatusSuccess(response1?.responseStatus)){
                console.log(response1);
            }
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',width:'100%',background:'white',height:'fit-content'}}>
                <NavbarHome />
                <div style={{display:'flex',flexDirection:'column',marginTop:'138px',alignItems:'center',alignSelf:'stretch'}}>
                    <div
                        className='demo1'
                    >
                        <h5 className='demo2'>{i18n.t('Laissez-nous vos coordonnées pour que notre équipe puisse vous contacter')}</h5>
                        <SelectComponent
                            setVal={(e) => {
                                setDemandeType(e.target.value);
                            }}
                            val={demandeType}
                            listVal={typeDemande}
                            label={i18n.t('Type de demande')}
                        />
                        <SelectRadioBtn
                            value={genre}
                            setValue={setGenre}
                            name="genre"
                            options={[
                                { label: 'Madame', optionValue: 'mme' },
                                { label: 'Monsieur', optionValue: 'mr' }
                            ]}
                        />
                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',alignSelf:'stretch'}}>
                            <TextFieldComponent
                                id="margin-none"
                                value={nom}
                                label={i18n.t('Nom')}
                                name='Nom'
                                onChange={(newValue) => {
                                    setNom(newValue.target.value);
                                }}
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'},
                                }}
                                style={{width:device=='desktop'?'50%':'100%'}}
                            />
                            <TextFieldComponent
                                id="margin-none"
                                value={prenom}
                                label={i18n.t('Prénom')}
                                name='Prenom'
                                onChange={(newValue) => {
                                    setPrenom(newValue.target.value);
                                }}
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'},
                                }}
                                style={{width:device=='desktop'?'50%':'100%'}}
                            />
                        </div>
                        <TextFieldComponent
                            id="margin-none"
                            value={nomEntreprise}
                            label={i18n.t('Entreprise')}
                            name='Entreprise'
                            onChange={(newValue) => {
                                setNomEntreprise(newValue.target.value);
                            }}
                            sx={{
                                '& > :not(style)': {borderRadius: '8px'},
                            }}
                            style={{width:'100%'}}
                        />
                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',alignSelf:'stretch'}}>
                            <TextFieldComponent
                                id="margin-none"
                                value={email}
                                label={i18n.t('Email')}
                                name='Email'
                                onChange={(newValue) => {
                                    setEmail(newValue.target.value);
                                }}
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'},
                                }}
                                style={{width:device=='desktop'?'50%':'100%'}}
                            />
                            <TextFieldComponent
                                id="margin-none"
                                value={tele}
                                label={i18n.t('Téléphone')}
                                name='Téléphone'
                                onChange={(newValue) => {
                                    setTele(newValue.target.value);
                                }}
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'},
                                }}
                                style={{width:device=='desktop'?'50%':'100%'}}
                            />
                        </div>
                        <TextFieldComponent
                            placeholder={i18n.t('Message')}
                            multiline
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            value={message}
                            onChange={(e) => {
                                setMessage(e.target.value);
                            }}
                            style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                            rows={4}
                            maxRows={5}
                        />
                        <p
                            className='Gru'
                            style={{order:'0',textAlign:'left'}}
                        >
                            {i18n.t('En cliquant sur "Envoyer", j\'accepte les')}<a href="termsOfService"> <span style={{ color: 'rgba(64, 144, 247, 1)' }}> {i18n.t('conditions générales')}</span></a>
                            <p
                                style={{
                                    color: 'rgba(64, 144, 247, 1)',
                                    fontFamily: 'Lato',
                                    fontStyle: 'normal',
                                    fontWeight: '400',
                                    fontSize: '14px',
                                    display: 'inline',
                                    lineHeight: '16px',
                                }}
                            >
                            </p> {i18n.t('d\'utilisation')}
                            {i18n.t('de High Tech Hires, y compris l\'accord d\'utilisation et la')}
                            <a href="privacyPolicy"><span style={{ color: 'rgba(64, 144, 247, 1)' }}> {i18n.t('politique de confidentialité.')}</span></a>
                        </p>
                        <Button
                            variant="contained"
                            type='submit'
                            size='medium'
                            onClick={demandeDemo}
                            style={{
                                ...buttonStylesBlue(false)
                            }}
                            startIcon={<ArrowForward />}
                        >
                            {i18n.t('Envoyer')}
                        </Button>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default DemandeDemo;